import { atom } from 'recoil';

const currentWorkOrder = atom<number | null>({
  key: 'currentWorkOrder',
  default: null,
});

export default currentWorkOrder;
